var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"label":_vm.label},model:{value:(_vm.weekday),callback:function ($$v) {_vm.weekday=$$v},expression:"weekday"}})
}
var staticRenderFns = []

export { render, staticRenderFns }